import { render, staticRenderFns } from "./business_new_time.vue?vue&type=template&id=48bfc3f4&scoped=true&"
import script from "./business_new_time.vue?vue&type=script&lang=ts&"
export * from "./business_new_time.vue?vue&type=script&lang=ts&"
import style0 from "./business_new_time.vue?vue&type=style&index=0&id=48bfc3f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bfc3f4",
  null
  
)

export default component.exports